import {initialVariant, chooseFinish, cleanCart} from './model.js';
const config = window.POCKET_CONFIG;
const variants = config?.variants || [];
const $ = selector => document.querySelector(selector);
const $$ = selector => [...document.querySelectorAll(selector)];
const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:config.currency || 'USD'}).format(value / 100);
const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const isShopify = config.mode === 'shopify';
const bag = $('[data-bag]');
const form = $('#purchase');
const stickyBuy = $('[data-sticky-buy]');
const stickyAdd = $('[data-sticky-add]');
const imageViewer = $('[data-image-viewer]');
const cartWallets = $('[data-cart-wallets]');
const mobileBuy = window.matchMedia('(max-width: 700px)');
const key = 'pocket-bag-v1';
const root = config.root || '/';
let current = initialVariant(variants, new URL(location.href).searchParams.get('variant'), config.defaultSku);
let cart = [];
let busy = false;
let toastTimer;
let imageIndex = 0;
let galleryImages = [];
let shopifySubtotal = 0;
document.documentElement.classList.add('js');
if (isShopify) $('[data-preview-note]')?.remove();

function notify(text) { $('[data-toast]').textContent=text; $('[data-toast]').classList.add('visible'); clearTimeout(toastTimer); toastTimer=setTimeout(()=>$('[data-toast]').classList.remove('visible'),3500); }
function showImage(index, play = false) {
  imageIndex = index;
  const image = $('[data-product-image]');
  const video = $('[data-product-video]');
  const media = galleryImages[index];
  if(!media)return;
  video.pause();
  $('[data-image-open]').hidden = media.type === 'video';
  $('[data-video-feedback]').hidden = true;
  image.hidden = media.type === 'video';
  video.hidden = media.type !== 'video';
  if (media.type === 'video') {
    if (video.getAttribute('src') !== media.src) { video.muted = true; video.src = media.src; }
    video.poster = media.poster;
    if(play){video.muted=true;video.play().catch(()=>{});}
  } else {
    image.src = media.src;
    const imageUrl=new URL(media.src,location.href);
    if(/\/cdn\/shop\/(files|products)\//.test(imageUrl.pathname)){
      image.srcset=[360,600,900,1200].map(width=>{const url=new URL(imageUrl);url.searchParams.set('width',String(width));return `${url.href} ${width}w`;}).join(', ');
      image.sizes='(max-width: 700px) 284px, (max-width: 1050px) 45vw, 650px';
    }else image.removeAttribute('srcset');
    image.alt = media.alt;
  }
  $$('[data-gallery] button').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
}
function renderVariant(announce = false) {
  if (!current) { $('[data-add-button]').disabled=true; $('[data-selection-status]').textContent='Choose a product in the theme editor to get started.'; return; }
  $('[data-finish-options]').innerHTML = [...new Set(variants.map(v=>v.finish))].map(finish=>`<button type="button" data-finish="${escapeHTML(finish)}" aria-pressed="${finish===current.finish}">${escapeHTML(finish)}</button>`).join('');
  const colors = variants.filter(v=>v.finish===current.finish);
  $('[data-color-options]').dataset.finish=current.finish;
  $('[data-color-options]').innerHTML = colors.map(v=>`<button type="button" data-color="${escapeHTML(v.color)}" aria-label="${escapeHTML(v.color)}${v.available?'':' — sold out'}" title="${escapeHTML(v.color)}${v.available?'':' — sold out'}" aria-pressed="${v.id===current.id}" ${v.available?'':'disabled'}><span class="color-swatch" style="--swatch:${/^#[0-9a-f]{6}$/i.test(v.swatch)?v.swatch:'#555555'}" aria-hidden="true"></span></button>`).join('');
  $('[data-color-name]').textContent=current.color;
  $('[data-price]').textContent=money(current.price);
  $('[data-currency]').textContent=config.currency;
  $('[data-variant-id]').value=current.id;
  $('[data-variant-id]').dispatchEvent(new Event('change',{bubbles:true}));
  syncPurchaseControls();
  $('[data-image-label]').textContent=`${current.finish} / ${current.color}`;
  galleryImages = [{src:current.image,thumbnail:current.thumbnail, alt:`${current.color} ${current.finish.toLowerCase()} card case, closed`}];
  if (current.sku === 'CJYD196677307GT' && config.overviewImage) galleryImages.unshift({src:config.overviewImage,alt:`Black carbon fiber-pattern ${config.title} wallet, open and closed`});
  if (config.productVideo?.src) galleryImages.push({type:'video',...config.productVideo,alt:`Product video (${Math.floor(config.productVideo.durationSeconds)} seconds)`});
  $('[data-gallery]').innerHTML=galleryImages.map((media,i)=>`<button type="button" data-image-index="${i}" class="${media.type==='video'?'video-thumbnail':''}" aria-label="${escapeHTML(media.type==='video'?`${config.labels.video_thumbnail}, ${config.labels.video_duration}`:media.alt)}" aria-pressed="${i===0}"><span class="thumbnail-picture"><img src="${escapeHTML(media.type==='video'?media.poster:media.thumbnail||media.src)}" alt="" width="46" height="46">${media.type==='video'?'<span class="video-play-icon" aria-hidden="true"></span>':''}</span>${media.type==='video'?`<span class="video-thumbnail-label">${escapeHTML(config.labels.video_thumbnail)}<small>${escapeHTML(config.labels.video_duration)}</small></span>`:''}</button>`).join('');
  showImage(0);
  if (announce) $('[data-selection-status]').textContent=`${current.finish} / ${current.color} selected.`;
  const url = new URL(location.href);
  if (url.searchParams.has('variant')) {
    url.searchParams.delete('variant');
    history.replaceState(null,'',url.pathname+url.search+url.hash);
  }
}
function savePreview() { try { localStorage.setItem(key,JSON.stringify(cart.map(item=>({sku:item.sku,quantity:item.quantity})))); } catch { /* The bag still works when browser storage is unavailable. */ } }
function previewItems(items) { return items.map(item=>({...variants.find(v=>v.sku===item.sku),...item,key:item.sku,title:config.title})); }
async function api(path, body) {
  const response = await fetch(root+path, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}});
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.description==='string' ? data.description : 'Couldn’t update the bag. Please try again.');
  return data;
}
function normalizeShopify(data) {
  shopifySubtotal = data.total_price;
  return data.items.map(item=>{const variant=variants.find(v=>String(v.id)===String(item.variant_id));return {...variant,id:item.variant_id,key:item.key,sku:item.sku,title:item.product_title,finish:variant?.finish || item.variant_title || '',color:variant?.color || '',quantity:item.quantity,price:item.final_price,image:item.featured_image?.url || item.image || variant?.image,linePrice:item.final_line_price};});
}
async function loadCart() {
  if(isShopify) cart=normalizeShopify(await api('cart.js'));
  else {let raw=[];try{raw=JSON.parse(localStorage.getItem(key)||'[]');}catch{} cart=previewItems(cleanCart(raw,variants));}
  renderCart();
}
function renderCart() {
  const count=cart.reduce((sum,item)=>sum+item.quantity,0);
  $$('[data-bag-count]').forEach(el=>el.textContent=count);
  $('[data-bag-items]').innerHTML = cart.length ? cart.map(item=>`<article class="bag-item"><img src="${escapeHTML(item.image)}" width="86" height="86" alt="${escapeHTML(item.color+' '+item.finish)}"><div><h3>${escapeHTML(item.title)}</h3><p>${escapeHTML(item.finish)} / ${escapeHTML(item.color)}</p><span class="line-price">${money(item.linePrice ?? item.price*item.quantity)}</span><div class="line-controls"><button type="button" data-change="${escapeHTML(item.key)}" data-quantity="${item.quantity-1}" aria-label="Decrease ${escapeHTML(item.finish+' '+item.color)} quantity" ${busy?'disabled':''}>−</button><output aria-label="Quantity">${item.quantity}</output><button type="button" data-change="${escapeHTML(item.key)}" data-quantity="${item.quantity+1}" aria-label="Increase ${escapeHTML(item.finish+' '+item.color)} quantity" ${busy||item.quantity>=99?'disabled':''}>+</button><button type="button" class="remove" data-change="${escapeHTML(item.key)}" data-quantity="0" aria-label="Remove ${escapeHTML(item.finish+' '+item.color)}" ${busy?'disabled':''}>Remove</button></div></div></article>`).join('') : '<p class="bag-empty">Just the essentials.<br>Your bag is empty.</p>';
  $('[data-subtotal]').textContent=money(isShopify ? shopifySubtotal : cart.reduce((sum,item)=>sum+item.price*item.quantity,0));
  if(cartWallets)$('[data-express-summary]').textContent=cart.length?`${cart.map(item=>`${item.finish} / ${item.color} x ${item.quantity}`).join(' · ')} — ${money(shopifySubtotal)} ${config.currency}`:config.labels.express_empty;
  $('[data-checkout]').disabled=!cart.length||busy;
  syncPurchaseControls();
}
function syncPurchaseControls() {
  const quantity=Number(form.elements.quantity.value);
  const validQuantity=Number.isSafeInteger(quantity)&&quantity>=1&&quantity<=10;
  const disabled=!current?.available||busy||!validQuantity;
  $('[data-add-button]').disabled=disabled;
  $('[data-add-button]').textContent=busy?'Adding…':current?.available?'Add to bag':'Sold out';
  form.setAttribute('aria-busy',String(busy));
  $('[data-buy-now]').disabled=disabled;
  if(stickyAdd){
    stickyAdd.disabled=disabled;
    stickyAdd.textContent=busy?'Adding…':current?.available?'Add to bag':'Sold out';
    stickyAdd.setAttribute('aria-label',`Add ${config.title}, ${current?.finish || ''} / ${current?.color || ''}, quantity ${quantity} to bag`);
    $('[data-sticky-price]').textContent=`${money(current?.price || 0)} ${config.currency}`;
    $('[data-sticky-variant]').textContent=`${current?.finish || ''} / ${current?.color || ''}${validQuantity&&quantity>1?' · Qty '+quantity:''}`;
  }
  const express=$('[data-express-buttons]');
  if(express){const unavailable=!cart.length||busy;express.toggleAttribute('inert',unavailable);express.setAttribute('aria-disabled',String(unavailable));}
}
function syncStickyBuy() {
  if(!stickyBuy)return;
  const mainButton=$('[data-add-button]');
  const rect=mainButton.getBoundingClientRect();
  const reserved=Math.max(stickyBuy.getBoundingClientRect().height,86);
  const mainVisible=rect.top>=0&&rect.bottom<=window.innerHeight-reserved;
  const editingQuantity=document.activeElement===form.elements.quantity;
  stickyBuy.hidden=!mobileBuy.matches||bag.open||imageViewer?.open||mainVisible||editingQuantity;
}
let stickyFrame;
function scheduleStickyBuy(){
  if(stickyFrame)return;
  stickyFrame=requestAnimationFrame(()=>{stickyFrame=null;syncStickyBuy();});
}
window.addEventListener('scroll',scheduleStickyBuy,{passive:true});
window.addEventListener('resize',scheduleStickyBuy);
window.visualViewport?.addEventListener('resize',scheduleStickyBuy);
form.addEventListener('focusin',scheduleStickyBuy);
form.addEventListener('focusout',scheduleStickyBuy);
new ResizeObserver(scheduleStickyBuy).observe(form);
bag.addEventListener('close',()=>{if(cartWallets)$('[data-main-express-slot]').append(cartWallets);syncStickyBuy();});
async function mutation(operation) {
  if(busy)return;
  busy=true;renderCart();
  $('[data-bag-message]').textContent='';
  try{await operation();if(!isShopify)savePreview();renderCart();return true;}
  catch(error){$('[data-bag-message]').textContent=error.message;notify(error.message);return false;}
  finally{busy=false;renderCart();}
}
function openBag(){if(cartWallets)$('[data-bag-express-slot]').append(cartWallets);bag.showModal();syncStickyBuy();}
$$('[data-open-bag]').forEach(button=>button.addEventListener('click',event=>{event.preventDefault();openBag();}));
$('[data-close-bag]').addEventListener('click',()=>bag.close());
bag.addEventListener('click',event=>{if(event.target===bag){const r=bag.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right)bag.close();}});
$('[data-finish-options]').addEventListener('click',event=>{const button=event.target.closest('[data-finish]');if(!button)return;const previousColor=current.color;current=chooseFinish(variants,current,button.dataset.finish);renderVariant(true);$('[data-finish][aria-pressed="true"]').focus();if(current.color!==previousColor)$('[data-selection-status]').textContent=`${previousColor} isn’t offered in ${current.finish.toLowerCase()}. ${current.color} selected.`;});
$('[data-color-options]').addEventListener('click',event=>{const button=event.target.closest('[data-color]');if(!button||button.disabled)return;current=variants.find(v=>v.finish===current.finish&&v.color===button.dataset.color);renderVariant(true);$('[data-color][aria-pressed="true"]').focus();});
$('[data-gallery]').addEventListener('click',event=>{const button=event.target.closest('[data-image-index]');if(button)showImage(Number(button.dataset.imageIndex),true);});
$('[data-product-video]').addEventListener('error',()=>{$('[data-video-feedback]').hidden=false;});
$('[data-video-retry]').addEventListener('click',()=>{const video=$('[data-product-video]');$('[data-video-feedback]').hidden=true;video.load();video.muted=true;video.play().catch(()=>{});});
$$('video').forEach(video=>video.addEventListener('play',()=>{$$('video').forEach(other=>{if(other!==video)other.pause();});}));

let viewerIndex=0;
let viewerPhotos=[];
let viewerScale=1;
let viewerPan={x:0,y:0};
let viewerOpener;
let viewerGesture;
let lastTap=0;
let lastTouchInteraction=0;
let viewerPinched=false;
const viewerPointers=new Map();
const viewerViewport=$('[data-viewer-viewport]');
const viewerImage=$('[data-viewer-image]');
function applyViewerTransform(){
  const ratio=(viewerImage.naturalWidth||1)/(viewerImage.naturalHeight||1);
  const width=Math.min(viewerViewport.clientWidth,viewerViewport.clientHeight*ratio);
  const height=width/ratio;
  const maxX=Math.max(0,(width*viewerScale-viewerViewport.clientWidth)/2);
  const maxY=Math.max(0,(height*viewerScale-viewerViewport.clientHeight)/2);
  viewerPan.x=Math.max(-maxX,Math.min(maxX,viewerPan.x));
  viewerPan.y=Math.max(-maxY,Math.min(maxY,viewerPan.y));
  viewerImage.style.transform=`translate(${viewerPan.x}px,${viewerPan.y}px) scale(${viewerScale})`;
  $('[data-viewer-zoom]').textContent=viewerScale>1.01?config.labels.zoom_out:config.labels.zoom_in;
  $('[data-viewer-zoom]').setAttribute('aria-pressed',String(viewerScale>1.01));
}
function showViewerPhoto(index){
  viewerIndex=(index+viewerPhotos.length)%viewerPhotos.length;
  const photo=viewerPhotos[viewerIndex];
  viewerImage.src=photo.src;
  viewerImage.alt=photo.alt;
  $('[data-viewer-count]').textContent=`${viewerIndex+1} / ${viewerPhotos.length}`;
  $('[data-viewer-previous]').disabled=viewerPhotos.length<2;
  $('[data-viewer-next]').disabled=viewerPhotos.length<2;
  viewerScale=1;viewerPan={x:0,y:0};lastTap=0;
  applyViewerTransform();
}
function toggleViewerZoom(){viewerScale=viewerScale>1.01?1:2;viewerPan={x:0,y:0};applyViewerTransform();}
$('[data-image-open]').addEventListener('click',()=>{
  viewerPhotos=galleryImages.filter(media=>media.type!=='video');
  viewerOpener=document.activeElement;
  imageViewer.showModal();
  showViewerPhoto(Math.min(imageIndex,viewerPhotos.length-1));
  syncStickyBuy();
});
$('[data-viewer-close]').addEventListener('click',()=>imageViewer.close());
imageViewer.addEventListener('close',()=>{viewerPointers.clear();viewerGesture=null;showImage(viewerIndex);viewerOpener?.focus({preventScroll:true});syncStickyBuy();});
$('[data-viewer-previous]').addEventListener('click',()=>showViewerPhoto(viewerIndex-1));
$('[data-viewer-next]').addEventListener('click',()=>showViewerPhoto(viewerIndex+1));
$('[data-viewer-zoom]').addEventListener('click',toggleViewerZoom);
viewerImage.addEventListener('load',applyViewerTransform);
viewerViewport.addEventListener('dblclick',event=>{event.preventDefault();if(Date.now()-lastTouchInteraction>500)toggleViewerZoom();});
imageViewer.addEventListener('keydown',event=>{
  if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showViewerPhoto(viewerIndex+(event.key==='ArrowRight'?1:-1));}
});
viewerViewport.addEventListener('pointerdown',event=>{
  viewerViewport.setPointerCapture(event.pointerId);
  viewerPointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
  if(viewerPointers.size===1){viewerPinched=false;viewerGesture={x:event.clientX,y:event.clientY,pan:{...viewerPan},scale:viewerScale};}
  else if(viewerPointers.size===2){
    const [a,b]=[...viewerPointers.values()];
    viewerPinched=true;lastTap=0;
    viewerGesture={distance:Math.hypot(a.x-b.x,a.y-b.y),scale:viewerScale};
  }
});
viewerViewport.addEventListener('pointermove',event=>{
  if(!viewerPointers.has(event.pointerId))return;
  viewerPointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
  if(viewerPointers.size===2&&viewerGesture?.distance){
    const [a,b]=[...viewerPointers.values()];
    viewerScale=Math.max(1,Math.min(3,viewerGesture.scale*Math.hypot(a.x-b.x,a.y-b.y)/viewerGesture.distance));
    applyViewerTransform();
  }else if(viewerPointers.size===1&&viewerGesture?.pan&&viewerScale>1){
    viewerPan={x:viewerGesture.pan.x+event.clientX-viewerGesture.x,y:viewerGesture.pan.y+event.clientY-viewerGesture.y};
    applyViewerTransform();
  }
});
function endViewerPointer(event){
  if(!viewerPointers.has(event.pointerId))return;
  if(event.pointerType==='touch')lastTouchInteraction=Date.now();
  viewerPointers.delete(event.pointerId);
  if(!viewerPointers.size&&!viewerPinched&&viewerGesture?.pan&&event.type!=='pointercancel'){
    const x=event.clientX-viewerGesture.x,y=event.clientY-viewerGesture.y;
    if(viewerGesture.scale===1&&Math.abs(x)>45&&Math.abs(x)>Math.abs(y)*1.2)showViewerPhoto(viewerIndex+(x<0?1:-1));
    else if(event.pointerType==='touch'&&Math.hypot(x,y)<12){const now=Date.now();if(now-lastTap<300){toggleViewerZoom();lastTap=0;}else lastTap=now;}
  }
  if(!viewerPointers.size)viewerGesture=null;
}
viewerViewport.addEventListener('pointerup',endViewerPointer);
viewerViewport.addEventListener('pointercancel',endViewerPointer);
window.addEventListener('resize',()=>{if(imageViewer.open)applyViewerTransform();});
async function purchaseSelection(destination='bag') {
  if(!current?.available||busy||!form.reportValidity())return;
  const quantity=Number(form.elements.quantity.value);if(!Number.isSafeInteger(quantity)||quantity<1||quantity>10)return;
  const selected=current;
  const success=await mutation(async()=>{if(isShopify){await api('cart/add.js',{items:[{id:selected.id,quantity}]});await loadCart();}else{const existing=cart.find(item=>item.sku===selected.sku);if(existing)existing.quantity=Math.min(99,existing.quantity+quantity);else cart.push({...selected,key:selected.sku,quantity,title:config.title});}});
  if(success){
    if(isShopify&&destination!=='bag'){location.assign(root+'checkout');return;}
    openBag();
    $('[data-bag-message]').textContent=destination==='bag'?`Added ${selected.finish.toLowerCase()} / ${selected.color}.`:'This is a local preview. Checkout is handled by the connected Shopify store.';
  }
}
form.addEventListener('submit',event=>{
  event.preventDefault();purchaseSelection();
});
$('[data-buy-now]').addEventListener('click',()=>purchaseSelection('checkout'));
$('[data-open-delivery]').addEventListener('click',()=>{$('#purchase-delivery').open=true;});
form.elements.quantity.addEventListener('input',syncPurchaseControls);
$('[data-bag-items]').addEventListener('click',async event=>{const button=event.target.closest('[data-change]');if(!button||busy)return;const quantity=Number(button.dataset.quantity);const itemKey=button.dataset.change;await mutation(async()=>{if(isShopify)cart=normalizeShopify(await api('cart/change.js',{id:itemKey,quantity}));else cart=cart.map(item=>item.key===itemKey?{...item,quantity}:item).filter(item=>item.quantity>0);});});
$('[data-checkout]').addEventListener('click',()=>{if(!cart.length||busy)return;if(isShopify)location.assign(root+'checkout');else $('[data-bag-message]').textContent='Checkout will be available once the Shopify store is connected. No order has been placed.';});
window.addEventListener('storage',event=>{if(!isShopify&&event.key===key)loadCart();});
config.overviewImage ||= './assets/wallet-supplier.webp';
renderVariant();
syncStickyBuy();
loadCart().catch(error=>{notify(error.message);$('[data-bag-message]').textContent=error.message;});
